/**
 * @fileoverview IrisCitationTag — small interactive numbered tag rendered
 * inline inside an agent's markdown reply (e.g. "...managed together¹").
 * Click reveals the citation popover; rendered as a `bp6-tag` so it
 * inherits Blueprint's hover/active states. Pass `number` (or any short
 * label) and an `onClick`/`onMouseEnter` for the popover trigger.
 *
 * Foundry mapping: `aip-assist-impl__citation-tag-wrapper > bp6-tag
 * .bp6-interactive.aip-assist-impl__citation-tag`.
 */

import { Tag } from "@blueprintjs/core";
import type { MouseEventHandler, ReactElement, ReactNode } from "react";

interface IrisCitationTagProps {
  number: ReactNode;
  onClick?: MouseEventHandler<HTMLElement>;
  className?: string;
}

export function IrisCitationTag({
  number,
  onClick,
  className,
}: IrisCitationTagProps): ReactElement {
  return (
    <span data-testid="iris-citation-tag" className="bp-iris-citation-tag-wrapper">
      <Tag
        interactive
        round={false}
        onClick={onClick}
        className={[
          "bp-iris-citation-tag",
          className,
        ]
          .filter(Boolean)
          .join(" ")}
      >
        {number}
      </Tag>
    </span>
  );
}
